import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { t } from 'src/lib/i18n-react'
import { Text, Box } from '@chatterbug/aaron'

const SearchResults = ({ results, isLoading }) => {
  const createMarkup = () => {
    return { __html: results }
  }
  if (isLoading) {
    return (
      <Text fontSize="2x" fontWeight="bold">
        {t('Fetching results')}
      </Text>
    )
  }
  return (
    <Box>
      <SC.SearchResults dangerouslySetInnerHTML={createMarkup()} />
    </Box>
  )
}
const SC = {}

SC.SearchResults = styled.div`
  .content-card-advanced {
    background-color: transparent;
    box-shadow: none;
    padding-left: 0px;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 16px;
  }
`

SearchResults.propTypes = {
  results: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
}

export default SearchResults
